"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _regeneratorRuntime2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _components = require("@/components");
var _user = require("@/api/data/user");
var _loginLog = require("@/api/data/loginLog");
var _date = require("@/utils/date.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'LoginLog',
  components: {
    PageInfo: _components.PageInfo
  },
  data: function data() {
    return {
      operatorList: [],
      searchForm: {
        created_at: null
      },
      listData: [],
      pagination: {
        page: 1,
        limit: 20,
        total: 100
      },
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  },
  activated: function activated() {
    this.init();
  },
  created: function created() {
    _date.initWeekDateRange.call(this);
    this.init();
  },
  methods: {
    fetchData: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(page) {
        var params, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.$route.meta.authList.includes('LoginLog/get')) {
                this.$router.go(-1);
                this.$message.error('没有查看权限');
              }
              if (page) this.pagination.page = page;
              params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.searchForm), this.pagination);
              _context.next = 5;
              return (0, _loginLog.getLoginLogList)(params);
            case 5:
              res = _context.sent;
              this.pagination.total = res.data.total;
              this.listData = res.data.list;
              this.listData.forEach(function (item) {
                item.address = item.province + (item.city && '-' + item.city);
              });
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchData(_x) {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }(),
    init: function init() {
      var _this = this;
      this.fetchData();
      var params = {
        page: 1,
        limit: 1000
      };
      (0, _user.getUserList)(params).then(function (res) {
        _this.operatorList = res.data.list.map(function (item) {
          return {
            label: "".concat(item.real_name, "-").concat(item.name),
            value: item.id
          };
        });
      });
    },
    /* 处理每页展示的数量改变事件 */handlePageSizeChange: function handlePageSizeChange(limit) {
      this.pagination.limit = limit;
      this.pagination.page = 1;
      // 重新加载表格数据
      this.fetchData();
    },
    /* 处理切页 */handlePageChange: function handlePageChange(page) {
      this.pagination.page = page;
      // 重新加载表格数据
      this.fetchData();
    }
  }
};
exports.default = _default;